export default "__VITE_ASSET__BnapPoMj__"